import { render } from "./ForYouCarousel.vue?vue&type=template&id=1ff7d8c6&scoped=true"
import script from "./ForYouCarousel.vue?vue&type=script&lang=js"
export * from "./ForYouCarousel.vue?vue&type=script&lang=js"

import "./ForYouCarousel.vue?vue&type=style&index=0&id=1ff7d8c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff7d8c6"]])

export default __exports__